'use strict';

module.exports = 'enhanceString';